import { Badge, Center } from '@chakra-ui/react';
import { TaskStatus } from '../../../models';
import { taskStatusTypeMapper } from '../utils';

export const TaskStatusBadge = ({
  status,
  isLate,
}: {
  status: TaskStatus;
  isLate?: boolean;
}) => {
  let bg = 'custom_green.4';
  let color = 'custom_green.1';

  if (status === TaskStatus.Cancelled) {
    color = 'custom_gray.9';
    bg = 'custom_gray.10';
  } else if (status === TaskStatus.Completed) {
    color = '#04D10C';
    bg = '#00FF0A08';
  } else if (status === TaskStatus.InProgress) {
    if (isLate) {
      color = '#FF0000';
      bg = '#FF000008';
    } else {
      color = '#2400FF';
      bg = '#0169F508';
    }
  } else if (status === TaskStatus.Late) {
    color = '#FF0000';
    bg = '#FF000008';
  }

  return (
    <Badge
      variant="subtle"
      borderRadius="8px"
      color={color}
      bg={bg}
      border={`1px solid ${color}`}
      textTransform="capitalize"
      width="100%"
      height="52px"
      fontSize="md"
      fontWeight="medium"
    >

      <Center h="full">
        <div style={{ height: "8px", width: "8px", background: color, borderRadius: "1000000px", marginRight: "8px" }}></div>
        {taskStatusTypeMapper(status, isLate)}</Center>
    </Badge>
  );
};
